// extracted by mini-css-extract-plugin
export default {"activityTemplatesListPage":"activity_templates_list_page___activityTemplatesListPage___d3a2a04c"};